export const fonts = (rtl: boolean) => (
	// siteLanguage === "ja-JP" || siteLanguage === "ja-jp" ? {
	// 	fonts: {
	// 		heading: `'MS Gothic', 'ＭＳ ゴシック' , 'MS ゴシック' , Msgothic, sans-serif`,
	// 		body: `'MS Gothic', 'ＭＳ ゴシック' , 'MS ゴシック' , Msgothic, sans-serif`,
	// 		overline: `'MS Gothic', 'ＭＳ ゴシック' , 'MS ゴシック' , Msgothic, sans-serif`,
	// 	}
	// } :
	{
		fonts: {
			heading: `'ManifaPro3', sans-serif`,
			body: rtl ? `'Haradh', sans-serif` : `'Ghawar', sans-serif`,
			overline: rtl ? `'ManifaPro3', sans-serif` : `'Ghawar', sans-serif`,
		}
	})